import { Route } from '@angular/router'
import { ChoiceFunction, QuizDataInput } from '@naturalcycles/shared'
import { addPageInSectionAfterPage } from '@src/app/core/util/quiz.util'
import { Page } from '@src/app/shared/typings/enum/pages'
import { DefaultSections } from '@src/app/shared/typings/enum/quiz'
import { QuizSelectOption } from '@src/app/shared/typings/interfaces/quiz'

export const ab398Routes: Route[] = [
  {
    path: Page.subGoals,
    loadComponent: () =>
      import('./sub-goals/sub-goals.page.component').then(m => m.SubGoalsPageComponent),
  },
]

export function getAb398GoalTransformFunction(
  existingTransformFunction: ChoiceFunction<Page, QuizDataInput> | undefined,
): ChoiceFunction<Page, QuizDataInput> {
  return (flow, data) => {
    flow = existingTransformFunction?.(flow, data) || flow
    flow = addPageInSectionAfterPage(flow, Page.subGoals, Page.fertilityGoal, DefaultSections.intro)
    return flow
  }
}

export enum SubGoal {
  findOutIfCycleIsNormal = 1,
  predictPeriod = 2,
  learnAboutHormones = 3,
  identifySymptomPatterns = 4,
  understandLibido = 5,
  tuneIntoMyBody = 6,
  skip = 7,
}

export const ab398Selections: QuizSelectOption[] = [
  {
    key: SubGoal.findOutIfCycleIsNormal,
    text: 'Find out if my cycle is normal',
  },
  {
    key: SubGoal.predictPeriod,
    text: 'Predict my period',
  },
  {
    key: SubGoal.learnAboutHormones,
    text: 'Learn about my hormones',
  },
  {
    key: SubGoal.identifySymptomPatterns,
    text: 'Identify symptom patterns',
  },
  {
    key: SubGoal.understandLibido,
    text: 'Understand my libido',
  },
  {
    key: SubGoal.tuneIntoMyBody,
    text: 'Tune into my body',
  },
]
